let subscribers = {};
function subscribe(s, r) {
  return (
    void 0 === subscribers[s] && (subscribers[s] = []),
    (subscribers[s] = [...subscribers[s], r]),
    function () {
      subscribers[s] = subscribers[s].filter((s) => s !== r);
    }
  );
}
function publish(s, r) {
  if (subscribers[s]) {
    const b = subscribers[s].map((s) => s(r));
    return Promise.all(b);
  }
  return Promise.resolve();
}
